import hook from '../../scripts/utilities/hook';
import moveTo from '../../scripts/utilities/moveTo';

const FAST_MENU_SELECTOR = hook('js-fast-menu');
const SELECT_SELECTOR = hook('js-fast-menu-select');

const ACTIVE_CLASS = 'is-sticky';
const FAST_MENU_HEIGHT = 60;

class FAST_MENU {
  constructor(element) {
    // early exist
    if (!element) {
      return;
    }

    this.element = element;

    if (!this.initSelector()) {
      return;
    }

    this.initSelector();

    this.initListeners();
  }

  // eslint-disable-next-line consistent-return
  initSelector() {
    this.select = this.element.querySelector(SELECT_SELECTOR);

    if (this.select) {
      return true;
    }
  }

  initListeners() {
    this.element.addEventListener('change', event => {
      this.goToHeading(event);
    });
    document.addEventListener('scroll', () => {
      this.setSticky();
    });
  }

  setSticky() {
    const bodyRect = document.body.getBoundingClientRect();
    const elementRect = this.element.getBoundingClientRect();
    this.elementY = elementRect.top - bodyRect.top;

    const mouseScrollY = window.pageYOffset;

    if (this.elementY < mouseScrollY) {
      this.element.classList.add(ACTIVE_CLASS);
    } else {
      this.element.classList.remove(ACTIVE_CLASS);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  goToHeading(event) {
    event.preventDefault();

    const currentOption = event.target.value;

    if (!currentOption.length > 0) {
      return;
    }

    const optionTarget = document.querySelector(`#${currentOption}`);

    if (!optionTarget) {
      return;
    }

    moveTo(optionTarget, FAST_MENU_HEIGHT);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(FAST_MENU_SELECTOR).forEach(element => {
    // eslint-disable-next-line no-unused-vars
    const elementCard = new FAST_MENU(element);
  });
});
